// Nome do arquivo dentro do caminho do Storage. O Supabase recusa chaves com
// acento, cedilha e vários símbolos ("Invalid key"), então um "Proposta São
// Paulo.docx" falhava no upload. O nome original continua em
// chat_attachments.file_name, que é o que o chat mostra e usa no download.
export function nomeSeguroParaStorage(nome: string): string {
  const pontoExt = nome.lastIndexOf('.');
  const temExt = pontoExt > 0 && pontoExt < nome.length - 1;
  const base = temExt ? nome.slice(0, pontoExt) : nome;
  const ext = temExt ? nome.slice(pontoExt + 1) : '';

  const limpar = (s: string) =>
    s
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^A-Za-z0-9._-]+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^[_.-]+|[_.-]+$/g, '');

  const baseLimpa = limpar(base) || 'arquivo';
  const extLimpa = limpar(ext);
  return extLimpa ? `${baseLimpa}.${extLimpa}` : baseLimpa;
}

interface ErroDeUpload {
  statusCode?: string | number;
  message?: string;
}

// Motivo da falha para quem tentou anexar — antes tudo virava "verifique sua
// conexão", inclusive arquivo grande demais.
export function mensagemDeErroDoAnexo(erro: unknown): string {
  const { statusCode, message = '' } = (erro ?? {}) as ErroDeUpload;
  const texto = message.toLowerCase();
  if (String(statusCode) === '413' || texto.includes('maximum allowed size') || texto.includes('too large')) {
    return 'O arquivo passa do tamanho máximo permitido.';
  }
  if (texto.includes('mime type') || String(statusCode) === '415') {
    return 'Esse tipo de arquivo não é aceito.';
  }
  return 'Verifique sua conexão e tente novamente.';
}
